import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import {
    UserSession,
    AdminUser,
    setDefaultData
  } from '../utils'
import { Client, Account, Databases, Functions } from "appwrite";

import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

const account = new Account(client);
const db = new Databases(client);
const functions = new Functions(client);


/**
 * Displays a popup tooltip with the provided text when the icon is hovered over.
 *
 * @param {String} text Required. Text for the tooltip.
 * @param {JSX.Element} icon Optional. Icon to display in the tooltip. If unspecified, defaults to an info icon.
 * 
 * @returns {JSX.Element} Rendered InfoTooltip component.
*/
export default function InfoTooltip({ text, icon }) {
    return (<Tooltip title={text ?? "No info available."} sx={{ ml: 0.25 }}>
        {icon || <InfoOutlinedIcon sx={{ ml: 0.25, fontSize: '1.3em', color: 'primary.main', my: 'auto', /*cursor: 'help'*/ }}/>}
    </Tooltip>)
}